import { GetTransactionsParams } from "@/models/payload/transaction";
import transactionService from "@/services/transaction";
import { useInfiniteQuery } from "@tanstack/react-query";

type Props = {
  params: GetTransactionsParams;
};

function useGetTransactions({ params }: Props) {
  const { data, isLoading, refetch, hasNextPage, fetchNextPage } =
    useInfiniteQuery({
      queryKey: ["transactions", params?.Term],
      queryFn: () => transactionService.getTransactions(params),
      getNextPageParam: (lastPage, allPages) => {
        const totalCount = lastPage?.count || 0;
        const itemsFetched = allPages.flatMap((page) => page.result).length;
        if (itemsFetched < totalCount) {
          // There are more items to fetch
          return itemsFetched;
        } else {
          // No more items to fetch
          return undefined;
        }
      },
    });

  return { data, isLoading, refetch, hasNextPage, fetchNextPage };
}

export default useGetTransactions;
